import {
    TOGGLE_DRAWER,
    CLOSE_DRAWER,
    SET_ACTIVE_MENU,
    SHOW_CONFIRMATION_POPUP,
    SET_PATH,
    SET_ACTIVE_NAME,
    CLEAR_ACTIVE_MENU,
} from '../actions/drawer';

// on refresh redux loses state so i grab the pathname early
// before any component mounts to avoid the active menu flash
const getInitialActiveMenu = () => {
    const pathname = window.location.pathname;

    // pathname is the only thing that survives a refresh
    // map it to the menu name before first render
    const pathMap = {
        '/dashboard': 'Dashboard',
        '/message-management': 'AddEditMessages',
        '/game-highlights': 'AddEditGameHighlights',
        '/games-review': 'RetailerGameView',
        '/games-list': 'GamesList',
        '/retailer-groups': 'RetailerGroups',
        '/planogram-list': 'Planograms',
        '/courier-list': 'Couriers',
        '/configuration-management': 'ConfigurationManagement',
        '/user-management': 'UserManagement',
        '/permissions-configuration': 'UserRolesPermissions',
        '/contact-us-configuration': 'ContactUsConfiguration',
        '/upload-management': 'UploadFiles',
        '/faq-management/private': 'FAQPrivate',
        '/faq-management/public': 'FAQPublic',
        '/privacy-policy/edit-policy': 'PrivacyPolicy',
        '/new-retailer-policy': 'NewRetailer',
    };

    // values must match SidebarItem._createName (strips non-alpha chars)
    return pathMap[pathname] || null;
};

const INITIAL_STATE = {
    open: false,
    activeMenu: getInitialActiveMenu(),
    showConfirmationPopup: false,
    path: null,
    name: null,
};

const drawer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case TOGGLE_DRAWER:
            return { ...state, open: action.payload || false };
        case CLOSE_DRAWER:
            return { ...state, open: false };
        case SET_ACTIVE_MENU:
            return { ...state, activeMenu: action.payload };
        case SHOW_CONFIRMATION_POPUP:
            return { ...state, showConfirmationPopup: action.payload };
        case SET_PATH:
            return { ...state, path: action.payload };
        case SET_ACTIVE_NAME:
            return { ...state, name: action.payload };
        case CLEAR_ACTIVE_MENU:
            return { ...INITIAL_STATE };
        default:
            return state;
    }
};

export default drawer;
